import React from "react";

export const Footer = () => {
    return <footer className="footer">
    </footer>;
};

